// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.cald_logout-container .link-button {
  font-family: "72-Regular";
}

.cald_logout-container {
  height: 100%;
  width: 100%;
  text-align: center;
  padding-top: 20%;
}
.cald_logout-container .link-button {
  border: none;
  background-color: transparent;
  font-size: 1.4rem;
  text-align: left;
  color: #498fe2;
}
.cald_logout-container .link-button:hover {
  background-color: transparent;
  color: #498fe2;
}
.cald_logout-container .link-button:focus {
  color: #498fe2 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/components/login/logout/logout.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AAFA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAKJ;AAJI;EACI,YAAA;EACA,6BAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;AAKR;AAJQ;EACE,6BAAA;EACA,cAAA;AAMV;AAJQ;EACE,yBAAA;AAMV","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../../assets/css/fonts';\n.cald_logout-container{\n    height: 100%;\n    width: 100%;\n    text-align: center;\n    padding-top: 20%;\n    .link-button{\n        border: none;\n        background-color: transparent;\n        font-size: 1.4rem;\n        @extend %font-regular;\n        text-align: left;\n        color: #498fe2;\n        &:hover {\n          background-color: transparent;\n          color: #498fe2;\n        }\n        &:focus {\n          color: #498fe2 !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
